import { Component, OnInit, Input, OnChanges, forwardRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ControlValueAccessor, NG_VALUE_ACCESSOR, NG_VALIDATORS } from '@angular/forms';
import { HhgBillOfLadingService } from 'src/app/services/hhg-bill-of-lading/hhg-bill-of-lading.service';
import { tap } from 'rxjs/operators';
@Component({
    selector: 'app-billoflading-finalization',
    templateUrl: './billoflading-finalization.component.html',
    styleUrls: ['./billoflading-finalization.component.css'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => BillofladingFinalizationComponent),
            multi: true
        },
        {
            provide: NG_VALIDATORS,
            useExisting: forwardRef(() => BillofladingFinalizationComponent),
            multi: true,
        }
    ],
    standalone: false
})
export class BillofladingFinalizationComponent implements ControlValueAccessor {
  @Input() additionalRemarks: string;
  @Input() billOfLadingNbr: string;
  billOfLadingShipmentFinalizationForm: UntypedFormGroup;
  finalization$ = this.hhgBillOfLadingService.HhgBolFinalizationDetails$
  .pipe(tap((finalizationDetail: any) => {
    if (finalizationDetail.hhgBolDetailsEntity != null) {
      finalizationDetail['billOfLadingNbr'] = finalizationDetail.hhgBolDetailsEntity.bolNumber;
    }
    this.billOfLadingShipmentFinalizationForm.patchValue(finalizationDetail, { emitEvent : true});
    this.billOfLadingShipmentFinalizationForm.patchValue({additionalRemarks: this.additionalRemarks});
  }));

  constructor(private fb: UntypedFormBuilder, private hhgBillOfLadingService: HhgBillOfLadingService) {
    this.billOfLadingShipmentFinalizationForm = this.fb.group({
      bolCorrectionNoticeId: new UntypedFormControl(''),
      billOfLadingNbr: new UntypedFormControl(''),
      correctionRemarks: new UntypedFormControl(''),
      authorityForCorrection: new UntypedFormControl(''),
      additionalRemarks: new UntypedFormControl(''),
      tspResponseDays: new UntypedFormControl(''),
      tspResponseHours: new UntypedFormControl(''),
      offlineBooking: new UntypedFormControl('')
    });
    this.billOfLadingShipmentFinalizationForm.valueChanges.subscribe(value => {
      this.onChange(value);
      this.onTouched();
    });
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  get value(): any {
    return this.billOfLadingShipmentFinalizationForm.value;
  }

  set value(value: any) {
    this.billOfLadingShipmentFinalizationForm.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value: any) {
    if (value) {
      this.value = value;
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  // communicate the inner form validation to the parent form
  validate(_: UntypedFormControl) {
    return this.billOfLadingShipmentFinalizationForm.valid ? null : { profile: { valid: false, }, };
  }
}
